import FormPlaceholder from "@app/component/placeholder/FormPlaceholder";
import React from "react";


const FormInPortletPlaceholder = React.memo(()=>{
    return <div className="mx-auto mt-8 lg:mx-0 lg:max-w-none bg-white p-4 sm:p-10 rounded-xl">
        <FormPlaceholder/>
    </div>
})

export default FormInPortletPlaceholder;